import {EcommercePaymentEvent} from 'web-angular-client';
import {sortLoadedRows} from '../row-sort';

/**
 * Orders payment events newest first. The engine already returns them in this order; sorting again here keeps the
 * panel right even if it does not. Ties keep the order they arrived in, and a missing or unparseable timestamp sinks
 * to the bottom.
 *
 * @param {EcommercePaymentEvent[]} events - the events from the payment state; may be null or undefined
 * @return {EcommercePaymentEvent[]} a new, reordered array
 */
export function sortPaymentEventsNewestFirst(
    events: readonly EcommercePaymentEvent[] | null | undefined): EcommercePaymentEvent[]
{
    return sortLoadedRows(events, eventTime, 'DESC');
}

function eventTime(event: EcommercePaymentEvent): number | null
{
    const time = event?.timestamp ? Date.parse(event.timestamp) : NaN;
    return Number.isNaN(time) ? null : time;
}
